module.exports = __webpack_public_path__ + "img/vector-shape2.0d81d5ff.png";